import React from 'react';
import { Helmet } from 'react-helmet';
import banner from '../assets/Gallery-Banner.png';
import MainServices from '../components/Gallery-Main-Services';
import GalleryHeader from '../components/GalleryHeader';
import WorkHighlightsCarousel from '../components/WorkHighlightsCarousel';
import InstaReelsCarousel from '../components/InstaReelsCarousel';
import Hero from '../components/Hero';
import Services from '../components/Services';
import { useNavigate } from 'react-router-dom';


const AboutUs = () => {

  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/service');
  };
  return (
    <>
    <Helmet>
<link rel="canonical" href="https://driveincarspa.com/gallery" />
<title>Gallery</title>
<meta name="description" content="" />
<meta name="keywords" content="" />
<meta name="author" content="DriveIn Team" />
</Helmet>
       <Hero
        title={<><span className="highlight">Shine in Every Frame – Explore the  </span><br /> Perfection We Delive</>}
        bgImage={banner}
        onButtonClick={handleServicesClick}
        buttonText='Services'
      />
      <GalleryHeader/> 
      <div style={{height: "120px"}}></div>
      <Services/>
      <div style={{height: "70px"}}></div>
      <WorkHighlightsCarousel/>
      <InstaReelsCarousel/>
    </>
  );
};

export default AboutUs;

